import React from 'react';
import { Translation } from '../translations';
import PricingCards from './PricingCards';

interface PricingSectionProps {
  t: Translation;
  language?: string;
}

const PricingSection: React.FC<PricingSectionProps> = ({ t, language = 'en' }) => {
  return (
    <section id="pricing" className="py-24 md:py-32 bg-gradient-to-b from-white to-gray-50 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-primary-100 rounded-full blur-3xl opacity-10"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-secondary-100 rounded-full blur-3xl opacity-10"></div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <div className="inline-flex items-center px-4 py-2 bg-primary-100 text-primary-700 rounded-full text-sm font-semibold mb-4">
            <span className="mr-2">💎</span>
            Flexible Pricing
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold bg-gradient-to-r from-gray-900 to-gray-700 bg-clip-text text-transparent mb-6">
            {t.pricing.title}
          </h2>
          <p className="text-xl md:text-2xl text-gray-600 max-w-3xl mx-auto">
            {t.pricing.subtitle}
          </p>
        </div>
        
        <PricingCards plans={t.pricing.plans} language={language} />
        
        {/* Trust badges */}
        <div className="mt-32 pt-8 text-center">
          <p className="text-gray-500 mb-6">
            {/* {language === 'ko' 
              ? '전 세계 10,000개 이상의 기업이 신뢰합니다 (준비중)'
              : 'Trusted by 10,000+ businesses worldwide (Coming Soon)'} */}
              Trusted by businesses worldwide
          </p>
          <div className="flex justify-center items-center gap-6 sm:gap-8 md:gap-12 flex-wrap opacity-80">
            <img 
              src="/img/Zara2.png" 
              alt="Zara" 
              className="h-8 sm:h-10 md:h-12 w-auto object-contain grayscale hover:grayscale-0 transition-all duration-300"
            />
            <img 
              src="/img/TradeBay.png" 
              alt="TradeBay" 
              className="h-8 sm:h-10 md:h-12 w-auto object-contain grayscale hover:grayscale-0 transition-all duration-300"
            />
            <img 
              src="/img/MediumCo.png" 
              alt="MediumCo" 
              className="h-8 sm:h-10 md:h-12 w-auto object-contain grayscale hover:grayscale-0 transition-all duration-300"
            />
            <img 
              src="/img/Kotra.png" 
              alt="Kotra" 
              className="h-8 sm:h-10 md:h-12 w-auto object-contain grayscale hover:grayscale-0 transition-all duration-300"
            />
            <img 
              src="/img/KoreaTrade.png" 
              alt="Korea Trade" 
              className="h-8 sm:h-10 md:h-12 w-auto object-contain grayscale hover:grayscale-0 transition-all duration-300"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;